/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GDPRConsentResponse } from './GDPRConsentResponse';
import {
    GDPRConsentResponseFromJSON,
    GDPRConsentResponseFromJSONTyped,
    GDPRConsentResponseToJSON,
} from './GDPRConsentResponse';

/**
 * 
 * @export
 * @interface GetConsentGdpr200ResponseAllOf
 */
export interface GetConsentGdpr200ResponseAllOf {
    /**
     * 
     * @type {GDPRConsentResponse}
     * @memberof GetConsentGdpr200ResponseAllOf
     */
    result?: GDPRConsentResponse;
}

/**
 * Check if a given object implements the GetConsentGdpr200ResponseAllOf interface.
 */
export function instanceOfGetConsentGdpr200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetConsentGdpr200ResponseAllOfFromJSON(json: any): GetConsentGdpr200ResponseAllOf {
    return GetConsentGdpr200ResponseAllOfFromJSONTyped(json, false);
}

export function GetConsentGdpr200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConsentGdpr200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : GDPRConsentResponseFromJSON(json['result']),
    };
}

export function GetConsentGdpr200ResponseAllOfToJSON(value?: GetConsentGdpr200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': GDPRConsentResponseToJSON(value.result),
    };
}

